module.exports = "<!--\r\nCopyright (c) 2016 HVIKT AS\r\n-->\r\n\r\n<div ui-view=\"admin\"></div>";